import Footer from './footer/footer.vue'
import NavTab from './navtab/navTab.vue'
import GonggeList from './gonggelist/gonggelist.vue'
import MenuList from './menulist/menulist.vue'
import Scrolls from './scrolls/scrolls.vue'
import Silder from './silder/silder.vue'
import Loadings from './loadings/loading.vue'
import FromInput from './fromInput/fromInput.vue'
import FromSwitch from './fromSwitch/fromSwitch.vue'
import FromSelect from './fromSelect/fromSelect.vue'
import BottomModal from './bottomModal/bottomModal.vue'
import FromTextArea from './fromTextArea/fromTextArea.vue'
import FromUploadImg from './fromUploadImg/fromUploadImg.vue'
import PreviewImage from './previewImage/previewImage.vue'

export {
  Footer,
  NavTab,
  GonggeList,
  MenuList,
  Scrolls,
  Silder,
  FromInput,
  Loadings,
  FromSwitch,
  FromSelect,
  BottomModal,
  FromTextArea,
  FromUploadImg,
  PreviewImage
}
